import React from 'react';
import PropTypes from 'prop-types';

const UISelectValue = ({
  label,
  onChange,
  name,
  setValue,
  value,
  options,
}) => (
  <div className="w-full">
    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">{label}</label>
    <div className="relative">
      <select
        className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
        value={value}
        name={name}
        onChange={e => (typeof onChange === 'function' ? onChange(e) : setValue(e.target.value))}
      >
        {options.map((o, index) => (<option value={o.value} key={`${o.value}_${index}`}>{o.label}</option>))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-black h-12 top-0">
        <svg
          className="fill-current h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
      </div>
    </div>
  </div>
);

UISelectValue.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  name: PropTypes.string,
  setValue: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  options: PropTypes.arrayOf(PropTypes.shape()),
};

UISelectValue.defaultProps = {
  label: '',
  onChange: null,
  name: '',
  value: '',
  setValue: () => {},
  options: [
    { value: 'true', label: 'Yes' },
    { value: 'false', label: 'No' },
  ],
};

export default UISelectValue;
